export function isNullOrEmpty(value: any): boolean {
  return (
    typeof value === 'undefined' ||
    value == null ||
    (typeof value === 'string' && value === '')
  );
}

export function deepCopy<T>(obj: T): T {
  if (isNullOrEmpty(obj)) {
    return obj;
  }

  const dateFormat = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(.*)/;
  function reviver(key: any, value: any): any {
    if (typeof value === 'string' && dateFormat.test(value)) {
      return new Date(value);
    }
    return value;
  }

  return JSON.parse(JSON.stringify(obj), reviver);
}
